module.exports = __webpack_public_path__ + "img/header-weddingRingsCeramic.c1fa407.webp";